export default "__VITE_ASSET__CRlLaote__"